import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, Router } from '@angular/router';

import { MenuComponent } from '../../core/components/kt/components';


@Injectable({
   providedIn: 'root'
})
export class SharedService {
   constructor(private readonly router: Router) { }

   routingChanges() {
      return this.router.events.subscribe((event) => {
         if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
            setTimeout(() => {
               MenuComponent.reinitialization();
            }, 200);
         }
      });
   }
}
